import React, { useState } from 'react';
import PropTypes from 'prop-types';

import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import makeStyles from '@material-ui/core/styles/makeStyles';

import { TitleTab, MasterObjectTab, BenchmarksTab, FiltersTab } from './components';

const useStyles = makeStyles({
  tabRoot: {
    textTransform: 'none',
    minWidth: '80px',
    fontSize: '14px'
  }
});

const tabs = [
  { index: 0, label: 'Title and Description' },
  { index: 1, label: 'Object Type & ID' },
  { index: 2, label: 'Series and Benchmarks' },
  { index: 3, label: 'Filters' }
];

const MainMenuSettings = ({
  title,
  description,
  masterObjectId,
  masterObjectTypeId,
  benchmarks,
  dashboardData,
  onSubmit,
  handleClose,
  timeSeriesSetId,
  widgetOverlayLists,
  setFilters
}) => {
  const classes = useStyles();
  const [value, setValue] = useState(0);

  const handleTabsChange = (event, newValue) => {
    setValue(newValue);
  };

  const handleSubmit = data => {
    onSubmit(data);
  };

  const renderTabs = () => {
    return tabs.map(tab => (
      (tab.label === 'Filters' && widgetOverlayLists.length < 1)
        ? null
        : (
          <Tab
            label={tab.label}
            value={tab.index}
            key={tab.index}
            disableRipple
            classes={{ root: classes.root }}
          />
        )
    ));
  };

  return (
    <>
      <Tabs value={value} variant="fullWidth" indicatorColor="primary" onChange={handleTabsChange}>
        {renderTabs()}
      </Tabs>

      <TitleTab
        value={value}
        onSubmit={handleSubmit}
        handleClose={handleClose}
        title={title}
        description={description}
      />
      <MasterObjectTab
        value={value}
        onSubmit={handleSubmit}
        handleClose={handleClose}
        masterObjectId={masterObjectId}
        masterObjectTypeId={masterObjectTypeId}
        dashboardData={dashboardData}
        timeSeriesSetId={timeSeriesSetId}
      />
      <BenchmarksTab
        value={value}
        benchmarks={benchmarks}
        onSubmit={handleSubmit}
        handleClose={handleClose}
        dashboardData={dashboardData}
      />
      <FiltersTab
        value={value}
        handleClose={handleClose}
        widgetOverlayLists={widgetOverlayLists}
        setFilters={setFilters}
      />
    </>
  );
};

MainMenuSettings.propTypes = {
  title: PropTypes.string,
  description: PropTypes.string,
  masterObjectId: PropTypes.number.isRequired,
  masterObjectTypeId: PropTypes.number,
  onSubmit: PropTypes.func.isRequired,
  handleClose: PropTypes.func.isRequired,
  benchmarks: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.string.isRequired,
      benchmarkId: PropTypes.number.isRequired
    })
  ),
  dashboardData: PropTypes.shape({
    masterObjectId: PropTypes.number.isRequired,
    masterObjectTypeId: PropTypes.number.isRequired,
    masterObjectName: PropTypes.string.isRequired,
    benchmarks: PropTypes.arrayOf(
      PropTypes.shape({
        name: PropTypes.string.isRequired,
        benchmarkId: PropTypes.number.isRequired
      })
    )
  })
};

MainMenuSettings.defaultProps = {
  title: null,
  description: null,
  masterObjectTypeId: null,
  benchmarks: [],
  dashboardData: {}
};

export default MainMenuSettings;
